import { css } from '@emotion/react';
import { media } from '@utex/ui-kit';

export const buttonStyle = css`
  padding: 0.6rem 1.6rem;

  @media ${media.phonablet} {
    padding: 0.6rem 2.1rem;
  }

  @media (max-width: 374px) {
    padding-left: 1.7rem;
    padding-right: 1.7rem;
  }
`;
